import { themes as tamaguiThemes } from "@tamagui/themes";

import { tokens } from "./tokens";

// Every app mounts with `defaultTheme="dark"`; `light` is kept only so
// Tamagui's light/dark pair stays complete.
export const themes = {
  ...tamaguiThemes,
  dark: {
    ...tamaguiThemes.dark,
    background: tokens.color.gray1,
    color: tokens.color.white,
  },
  light: {
    ...tamaguiThemes.light,
    background: tokens.color.white,
    color: tokens.color.black,
  },
};
